import { SearchIcon } from "components/Icons";
import React from "react";

export const SearchRecord = ({
  data,
  setSearchData,
  resetSearchData,
  title = "",
  width = "max-w-md",
  placeholder = null,
}) => {
  const handleSearchRecord = (value) => {
    let _value = value;
    let filterActivities = [];
    if (_value === "") {
      resetSearchData();
    } else {
      filterActivities = data.filter((activity) => {
        const activityName = activity.name.toLowerCase();
        return activityName.includes(_value.toLowerCase());
      });
    }

    if (filterActivities.length > 0) {
      setSearchData(filterActivities);
    }
  };

  return (
    <div
      className={`mx-auto  border border-gray-300  p-2  flex items-center justify-between shadow-md rounded-full py-3 px-4  text-neutral-800 focus-within:border focus-within:border-cyan-500 bg-white mb-2 ${width}`}
    >
      <input
        type="text"
        id="searchActi"
        onChange={(e) => handleSearchRecord(e.target.value)}
        placeholder={title || placeholder}
        className="relative w-full ml-1 placeholder-opacity-50 placeholder:text-gray-300 text-md placeholder:text-lg focus:border-none focus:outline-none"
      />
      <SearchIcon className="m-auto h-6 w-6 fill-current text-neutral-500 active:text-sky-600 cursor-pointer active:scale-90 hover:text-blue-700" />
    </div>
  );
};
